import React from 'react';
import classes from "./Background.module.css";

const Background = React.memo(() => {
  return <div className={classes.bg}></div>;
});

export default Background;
